import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-users-stats-page',
  templateUrl: './top-users-stats-page.component.html',
  styleUrls: ['./top-users-stats-page.component.css']
})
export class TopUsersStatsPageComponent implements OnInit {

  constructor(
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Top Users | ' + environment.title);
  }

}
